export const DISPLAY_SETTINGS_KEY = 'display-settings';
export const DISPLAY_SETTINGS_SCOPE = 'ui-inventory.display-settings.manage';
